import { safeLocalStorage } from '@hooks/useStorage'

export type TourStateValue = 'completed' | 'dismissed' | 'later' | null

const keyFor = (tourId: string) => `tour.${tourId}`

export function getTourState(tourId: string): TourStateValue {
  const raw = safeLocalStorage.getItem(keyFor(tourId))
  if (raw === null) return null
  if (raw === 'completed' || raw === 'dismissed' || raw === 'later') {
    return raw
  }
  return null
}

function setTourState(tourId: string, tourState: TourStateValue) {
  const tourKey = keyFor(tourId)

  if (tourState === null) {
    safeLocalStorage.removeItem(tourKey)
  } else {
    safeLocalStorage.setItem(tourKey, tourState)
  }
}

export const markCompleted = (tourId: string) => setTourState(tourId, 'completed')
export const markDismissed = (tourId: string) => setTourState(tourId, 'dismissed')
export const markLater = (tourId: string) => setTourState(tourId, 'later')
export const clearTourState = (tourId: string) => setTourState(tourId, null)
